import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const yOffset = 80;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    landscape: {
      baseWidth: width * 1.08,
      baseHeight: height,
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(-70),
        y: convertToPercentageY(133 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(23),
        y: convertToPercentageY(101 + yOffset),
        duration: 100,
      },
      {
        x: convertToPercentageX(90),
        y: convertToPercentageY(148 + yOffset),
        duration: 100,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_4'));
        },
      },
      {
        wait: 1200,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_1'));
        },
      },
      {
        y: convertToPercentageY(105 + yOffset),
        duration: 70,
      },
      {
        y: convertToPercentageY(84 + yOffset),
        duration: 30,
        callback: (object, config) => {
          const { parent } = config;
          parent.addChildAt(object, 0);
        },
      },
      {
        y: convertToPercentageY(147 + yOffset),
        duration: 70,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_2_1'),
    landscape: {
      baseWidth: width * 1.08,
      baseHeight: height,
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(704),
        y: convertToPercentageY(109 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
        },
      },
      {
        x: convertToPercentageX(640),
        y: convertToPercentageY(90 + yOffset),
        duration: 100,
      },
      {
        x: convertToPercentageX(537),
        y: convertToPercentageY(148 + yOffset),
        duration: 100,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_2_4'));
          G.sfx.whoosh.play();
        },
      },
      {
        wait: 970,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_2_1'));
          G.sfx.xylophone_positive_12.play();
        },
      },
      {
        y: convertToPercentageY(102 + yOffset),
        duration: 100,
        callback: (object, config) => {
          const { parent } = config;
          parent.addChildAt(object, 0);
        },
      },
      {
        y: convertToPercentageY(113 + yOffset),
        duration: 35,
      },
      {
        y: convertToPercentageY(145 + yOffset),
        duration: 100,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(314),
        y: convertToPercentageY(583),
        alpha: 0,
        scale: 0.66,
      },
      {
        wait: 400,
      },
      {
        alpha: 1,
        scale: 0.9,
        duration: 66,
      },
      {
        scale: 1.7,
        duration: 201,
        callback: () => {
          G.sb('corruptWindow').dispatch();
        },
      },
      {
        alpha: 0.4,
        scale: 2.15,
        duration: 100,
      },
      {
        alpha: 0,
        duration: 67,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      // Initial transform
      {
        x: convertToPercentageX(318),
        y: convertToPercentageY(605),
        alpha: 0,
        angle: 90,
        scale: 0.65,
      },
      {
        wait: 400,
      },
      {
        wait: 99,
      },
      {
        alpha: 1,
        angle: 0,
        scale: 1.3,
        duration: 268,
      },
      {
        alpha: 0.35,
        angle: -32,
        scale: 1.55,
        duration: 99,
      },
      {
        alpha: 0,
        duration: 68,
      },
    ],
  },
];
